import { ActionTypes } from "../constants/action-types";

const initialState = {
  hackathons: [],
  totalhackathons: 0,
};

export const FetchHackathons = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_HACKATHON_SUCCESS:
      return {
        ...state,
        hackathons: action.payload,
        totalhackathons: action.payload.length,
      };

    default:
      return state;
  }
};

export default FetchHackathons;
